export function buildListingInquiryMessage(listingCode: string): string {
  return `${listingCode} kodlu ilan hakkında bilgi almak istiyorum.`;
}
